export default "__VITE_ASSET__CgvB7_Ct__"